import {useSelector} from "react-redux";

export const RolesValidator = (rolesCanView) => {
    const userRoles = useSelector((state) => state.login.roles);
    return rolesCanView.filter(role => userRoles.includes(role)).length > 0;
}